import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { initAnalytics, readConsent, updateConsent } from "@/lib/analytics";

/** Banner cookie: analytics attivo solo dopo l'accettazione (Consent Mode v2). */
export function CookieConsent() {
  const [choice, setChoice] = useState(() => readConsent());

  useEffect(() => {
    initAnalytics();
  }, []);

  if (choice) return null;

  const decide = (granted) => {
    updateConsent(granted);
    setChoice(granted ? "granted" : "denied");
  };

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Preferenze cookie"
      className="fixed bottom-16 lg:bottom-4 left-4 right-4 z-[70] mx-auto max-w-xl border border-wood/20 bg-cream/95 backdrop-blur-md p-5 shadow-lg"
    >
      <p className="text-sm leading-relaxed text-foreground/75">
        Usiamo cookie tecnici necessari al sito e, solo con il tuo consenso, cookie di statistica
        anonima per capire quali pagine sono più utili. Nessun dato personale viene condiviso.{" "}
        <Link to="/cookie-policy" className="text-sage underline underline-offset-4">
          Cookie policy
        </Link>
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => decide(true)}
          data-testid="cookie-accept"
          className="px-6 py-3 bg-sage text-cream text-[0.66rem] uppercase tracking-[0.18em] hover:bg-wood transition-colors duration-400"
        >
          Accetto
        </button>
        <button
          type="button"
          onClick={() => decide(false)}
          data-testid="cookie-decline"
          className="px-6 py-3 border border-wood/30 text-wood text-[0.66rem] uppercase tracking-[0.18em] hover:bg-wood hover:text-cream transition-colors duration-400"
        >
          Solo necessari
        </button>
      </div>
    </div>
  );
}

export default CookieConsent;
